import Froogaloop from 'vimeo-froogaloop';

export default function playVideo() {
    const playBtn = jQuery('.video-play-btn');

    if (playBtn.length) {
        playBtn.each(function () {
            jQuery(this).on('click', function () {
                jQuery(this).toggleClass('is-playing');
                const uploadVideo = jQuery(this).parent().find('video');
                const iframe = jQuery(this).parent().find('iframe')[0];

                let btnSrc = jQuery(this).find('use').attr('xlink:href');
                btnSrc = btnSrc.replace('play', 'pause');
                // let videoOverlay = jQuery('#videoOverlay');

                if (uploadVideo.length) {
                    if (uploadVideo.get(0).paused) {
                        btnSrc = btnSrc.replace('play', 'pause');
                        jQuery(this).find('use').attr('xlink:href', btnSrc);
                        uploadVideo.get(0).play();
                    } else {
                        uploadVideo.get(0).pause();
                        btnSrc = btnSrc.replace('pause', 'play');
                        jQuery(this).find('use').attr('xlink:href', btnSrc);
                    }
                }

                if (iframe) {
                    const player = $f(iframe);
                    if (playBtn.hasClass('is-playing')) {
                        btnSrc = btnSrc.replace('play', 'pause');
                        player.api('play');
                        // videoOverlay.fadeOut();
                    } else {
                        btnSrc = btnSrc.replace('pause', 'play');
                        player.api('pause');
                        // videoOverlay.fadeIn();
                    }
                    jQuery(this).find('use').attr('xlink:href', btnSrc);
                } else {
                    // Handle unsupported video type or no video found
                }
            });
        });
    }
}
